import React, { Suspense } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useQueryClient } from 'react-query';

import { UserInfoWithLzPzus } from 'api';
import { isRoleGuard } from 'common/utils/roles';
import { EQueryConst } from 'features/service/config';
import { ERouteUrl, IRoute } from './config';

const RouteWithSubRoutes = (route: IRoute) => {
  /** В системе есть роль, значит можем графдировать роуты */
  const queryClient = useQueryClient();
  const user: UserInfoWithLzPzus | undefined = queryClient.getQueryData(EQueryConst.CURRENT_USER);
  // eslint-disable-next-line
  const renderRoute = (renderedRoute: IRoute, props: any) => {
    if (renderedRoute.redirect) return <Redirect to={renderedRoute.redirect} />;
    if (renderedRoute.private) {
      if (user && renderedRoute.roleGuard && isRoleGuard(renderedRoute.roleGuard, user?.roles)) {
        return renderedRoute.component && <renderedRoute.component {...props} routes={renderedRoute.routes} />;
      }
      return <Redirect to={ERouteUrl.LOGIN} />;
    }

    return renderedRoute.component && <renderedRoute.component {...props} routes={renderedRoute.routes} />;
  };
  return (
    <Suspense fallback={route.fallback}>
      <Route path={route.path} render={props => renderRoute(route, props)} />
    </Suspense>
  );
};

export default RouteWithSubRoutes;
